'use client'

import Heart from '@/app/_components/sections/hero/svgs/Heart'
import ThreeStar from '@/app/_components/sections/hero/svgs/ThreeStar'
import BigStar from '@/components/svgs/BigStarSvg/BigStar'
import Plane from '@/components/svgs/Plane'
import ThreeStars from '@/components/svgs/ThreeStarsSvg/threeStars'
import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { IconLock } from '@tabler/icons-react'
import Link from 'next/link'

export default function ForbiddenPage() {
	return (
		<div className="relative min-h-[80vh] flex justify-center items-center">
			<Heart className="absolute left-10 bottom-44 w-[10%] -rotate-12 animate-fade-in-move-right" />
			<Heart className="absolute left-36 bottom-44 z-10 w-[8%] rotate-[30deg] animate-fade-in-move-right" />
			<ThreeStars className="absolute top-10 right-10 z-50 w-[8%] rotate-[-40deg] scale-105 fill-background" />
			<ThreeStar className="absolute top-0 left-20 z-[10] w-[10%] rotate-[50deg] animate-fade-in-move-right fill-background" />
			<Plane className="absolute top-0 z-[0] w-[25%] -rotate-[18deg] animate-fade-in-move-down" />
			<BigStar className="absolute animate-fade-in-move-left bottom-44 right-10 w-[15%]" />

			<Stack align="center" justify="center" gap="lg" className="z-10 max-w-xl p-8">
				<Center>
					<IconLock size={80} color="#814256" stroke={1.5} />
				</Center>

				<Title className="font-patrick text-center text-wine">Acesso Restrito</Title>

				<Text size="lg" ta="center">
					Você não tem permissão para acessar esta página.
				</Text>

				<Text c="dimmed" ta="center">
					Esta área requer permissões especiais ou você pode ter sido redirecionado por engano.
				</Text>

				<Link href="/">
					<Button variant="outline" size="md">
						Voltar para a página inicial
					</Button>
				</Link>
			</Stack>
		</div>
	)
}
